/**
 * The telehealth informed consent is a static PDF, copied byte-for-byte from
 * the legacy registration app so members sign the same document. It is served
 * from `apps/web/public`, so the link is root-relative.
 */
export const TELEHEALTH_CONSENT_PDF_PATH =
  '/legal/informed-consent-telehealth-services-member-rights.pdf';
